import { Box, Container, Typography } from '@mui/material';
import { theme } from './generals/theme';
import useIsMobile from './hooks/useIsMobile';
import PageLink from './PageLink';
import './Hero.css';

function Hero() {
    const isMobile = useIsMobile();

    return (
        <Box
            sx={{
                width: '100%',
                height: { xs: '85vh', md: 'calc(100vh + 170px)' },
                position: 'relative',
            }}
            id="hero"
        >
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: '100%',
                    height: { xs: 400, md: 400 },
                    zIndex: 5,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        width: '100%',
                        height: '50%',
                        backgroundImage: `linear-gradient(transparent, ${theme.palette.primary.light})`,
                        zIndex: 6,
                    }}
                >
                </Box>
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: '100%',
                        height: '50%',
                        backgroundImage: `linear-gradient(${theme.palette.primary.light}, ${theme.palette.primary.dark})`,
                        zIndex: 6,
                    }}
                >
                </Box>
            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: '100%',
                    width: '100%',
                    backgroundImage: 'url(/img/hero.png)',
                    backgroundSize: { xs: 'cover', md: 'stretch' },
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    filter: 'brightness(0.7)',
                    zIndex: 4,
                }}
            >
            </Box>
            <img
                src="/img/frame_o.png"
                alt=""
                style={{
                    width: '100%',
                    height: 'auto',
                    position: 'absolute',
                    filter: 'brightness(1.4)',
                    animation: 'textGlow 3s infinite',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 5,
                }}
            />
            <img
                src="/img/textzug_h.png"
                alt=""
                style={{
                    width: isMobile ? '80%' : '40%',
                    height: 'auto',
                    position: 'absolute',
                    top: isMobile ? 40 : 180,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    transition: 'filter 1s',
                    filter: 'brightness(1.4)',
                    animation: 'textGlow 3s infinite',
                    right: 0,
                    zIndex: 6,
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 10,
                    left: '50%',
                    width: '80%',
                    transform: 'translateX(-50%)',
                    zIndex: 5,
                }}
            >
                <Typography
                    variant={isMobile ? 'h6' : 'h3'}
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    WILLKOMMEN BEI IHRER VIRTUELLEN REISE DURCH TAIPEI
                </Typography>
                <Container
                    maxWidth="md"
                    sx={{
                        display: 'flex',
                        py: 4,
                        justifyContent: 'space-around',
                    }}
                >
                    <PageLink
                        text="INFO"
                        image="/img/info.png"
                        link="info"
                    />
                    <PageLink
                        text="VIDEO"
                        image="/img/video.png"
                        link="video"
                    />
                    <PageLink
                        text="FOTOS"
                        image="/img/fotos.png"
                        link="fotos"
                    />
                </Container>
            </Box>
        </Box>

    );
}

export default Hero;
